import React from 'react';
import { Layout, Zap, Layers, ArrowRight, Shield, CheckCircle } from 'lucide-react';

const LandingPage = ({ onGetStarted }) => {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      {/* --- Navbar --- */}
      <nav className="flex items-center justify-between px-6 py-4 max-w-7xl mx-auto">
        <div className="flex items-center space-x-2">
          <div className="bg-indigo-600 p-2 rounded-lg">
            <Layout className="text-white h-5 w-5" />
          </div>
          <span className="text-xl font-bold tracking-tight">Proyect Agent</span>
        </div>
        <div className="hidden md:flex items-center space-x-6">
          <a href="#features" className="text-sm font-medium text-gray-500 hover:text-gray-900">Características</a>
          <a href="#pricing" className="text-sm font-medium text-gray-500 hover:text-gray-900">Precios</a>
          <button onClick={onGetStarted} className="text-sm font-medium text-indigo-600 hover:text-indigo-500">Iniciar Sesión</button>
          <button 
            onClick={onGetStarted}
            className="bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-gray-800 transition-colors"
          >
            Comenzar Gratis
          </button>
        </div>
      </nav>

      {/* --- Hero Section --- */}
      <section className="pt-20 pb-32 px-6 text-center max-w-5xl mx-auto">
        <div className="inline-flex items-center space-x-2 bg-indigo-50 border border-indigo-100 rounded-full px-3 py-1 mb-8">
          <span className="flex h-2 w-2 rounded-full bg-indigo-600"></span>
          <span className="text-xs font-semibold text-indigo-700 uppercase tracking-wide">Proyect Agent: Versión 1.0</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6 text-gray-900 leading-tight">
          Gestión de trabajo que se <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">adapta a ti.</span>
        </h1>
        
        <p className="text-xl text-gray-500 mb-10 max-w-2xl mx-auto leading-relaxed">
          Lo mejor de la simplicidad de las listas de tareas combinado con la potencia de las bases de datos relacionales. Un sistema, dos modos de trabajo.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <button 
            onClick={onGetStarted}
            className="w-full sm:w-auto px-8 py-4 bg-indigo-600 text-white rounded-xl font-bold text-lg hover:bg-indigo-700 transition-all transform hover:scale-105 shadow-lg shadow-indigo-200 flex items-center justify-center"
          >
            Probar Demo Interactiva <ArrowRight className="ml-2 h-5 w-5" />
          </button>
          <button className="w-full sm:w-auto px-8 py-4 bg-white text-gray-700 border border-gray-200 rounded-xl font-bold text-lg hover:bg-gray-50 transition-colors">
            Ver Video
          </button>
        </div>
      </section>

      {/* --- Features Grid --- */}
      <section id="features" className="bg-gray-50 py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-12">
            {/* Feature 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
              <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6 text-blue-600">
                <CheckCircle size={24} />
              </div>
              <h3 className="text-xl font-bold mb-3">Modo Simple (Asana)</h3>
              <p className="text-gray-500 leading-relaxed">
                Interfaz limpia enfocada en "hacer". Checklists, fechas límite y asignados sin el ruido visual de configuraciones complejas.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 right-0 bg-indigo-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg">Popular</div>
              <div className="h-12 w-12 bg-purple-100 rounded-lg flex items-center justify-center mb-6 text-purple-600">
                <Layers size={24} />
              </div>
              <h3 className="text-xl font-bold mb-3">Modo Avanzado (Monday)</h3>
              <p className="text-gray-500 leading-relaxed">
                Transforma tus listas en bases de datos. Columnas personalizadas, cronogramas, presupuestos y dependencias complejas.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
              <div className="h-12 w-12 bg-yellow-100 rounded-lg flex items-center justify-center mb-6 text-yellow-600">
                <Zap size={24} />
              </div>
              <h3 className="text-xl font-bold mb-3">Automatización No-Code</h3>
              <p className="text-gray-500 leading-relaxed">
                "Cuando el estado cambie a Listo, envía un email". Crea reglas poderosas sin escribir una sola línea de código.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- Trust/Footer simplified --- */}
      <section className="py-20 border-t border-gray-100 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl font-bold mb-8">Diseñado para escalar contigo</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center opacity-50 grayscale">
            <div className="font-bold text-xl">ACME Corp</div>
            <div className="font-bold text-xl">GlobalTech</div>
            <div className="font-bold text-xl">Stark Ind</div>
            <div className="font-bold text-xl">Wayne Ent</div>
          </div>
        </div>
      </section>
      
      <footer className="bg-white py-8 text-center text-sm text-gray-400 border-t border-gray-100">
        © 2023 Proyect Agent Systems. Todos los derechos reservados.
      </footer>
    </div>
  );
};

export default LandingPage;